import React, { useState } from 'react';
import { Row, Col, Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import EditReconciliationModal from './edit-reconciliation-modal';
import useStyles from '../../style.js';

const ReconciliationSetting = ({ landlord, getLandlord, updateLandlord }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const descriptionsArr = [
    {
      label: t('cms.landlord.invoice_info.reconciliation_setting.preference_label'),
      value: landlord.reconciliationPreference
        ? t(`cms.landlord.modal.${landlord.reconciliationPreference.toLowerCase()}.option`)
        : '-',
    },
    {
      label: t('cms.landlord.detail.reconciliation_frequency.label'),
      value: landlord.reconciliationFrequency
        ? t(`cms.landlord.modal.${landlord.reconciliationFrequency.toLowerCase()}.option`)
        : '-',
    },
    {
      label: t('cms.landlord.invoice_info.reconciliation_setting.booking_confirm_label'),
      value: landlord.bookingAutoConfirm
        ? t('cms.properties.edit.detail.tenancy_agreement.calculate_type.option.on')
        : t('cms.landlord.invoice_info.reconciliation_setting.lable'),
    },
    {
      label: t('cms.landlord.invoice_info.reconciliation_setting.option_label'),
      value: landlord.reconciliationOption
        ? t(
            `cms.landlord.modal.reconciliation_option.${landlord.reconciliationOption.toLowerCase()}.option`,
          )
        : '-',
    },
  ];
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            title={t('cms.landlord.invoice_info.title.reconciliation_setting')}
            extra={
              <span
                className={classes.formOutLineIcon}
                onClick={() => {
                  setVisible(true);
                }}
              >
                {t('cms.sepcial_offer.edit.btn')}
              </span>
            }
            className={classes.cardWrapper}
          >
            <Descriptions column={1} className={classes.descriptionWrapper}>
              {descriptionsArr.map(description => (
                <Descriptions.Item
                  label={description.label}
                  key={`reconciliation_setting${description.label}`}
                >
                  {description.value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Card>
        </Col>
      </Row>
      <EditReconciliationModal
        landlord={landlord}
        getLandlord={getLandlord}
        updateLandlord={updateLandlord}
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </>
  );
};
ReconciliationSetting.propTypes = {
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
};

export default ReconciliationSetting;
